import React from 'react';
// Dependency Imports
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import { updateUserSettings, clearAllSavedFilters, addFavoriteFilter } from '../../../store/user/actions';
import dayjs from 'dayjs';
import axios from 'axios';
import Select from 'react-select';
import Highlighter from 'react-highlight-words';
// Custom Component Imports
import IconButton from '../../common/IconButton';
import DatePicker from '../../common/DatePicker';
import TimeAgoSelect from '../../common/TimeAgoSelect';
// Utilities, helpers, types
import CollapsibleArea from '../../common/CollapsibleArea';
import FormControlClear from '../../common/FormControlClear';
import { useDebounce } from '../../../utilities/CustomHooks';
import AxiosConfig from '../../../utilities/AxiosConfig';
import { AppState } from '../../../store';
import { getSavedFilter, useQuery } from '../../../utilities/helper';
import { InputGroup } from 'react-bootstrap';
import Checkbox from '../../common/checkbox';

interface StateOption {
    name: string;
    code: string;
}

interface Result {
    Address: string;
    City: string;
    County: string;
    ELMArea: string;
    Excavator: string;
    ImportDate: string | Date;
    ProfitCenterID: number;
    State: string;
    TicketID: number;
    TicketNum: string;
    TicketRevision: string;
    TicketType: string;
    ProfitCenter: string;
}

interface Suggestion {
    fieldName: string;
    value: string | number | Array<any>;
    raw: any;
}

interface Options {
    City: Array<any>;
    states: Array<{ code: string; name: string }>;
    Excavator: Array<any>;
    profitCenters: Array<{ profitCenterFullName: string, profitCenterId: number, profitCenterName: string, stateCode: string }>
}

interface Filters {
    startts: number;
    endts: number;
    Address: string;
    City: string;
    states: Array<{ label: string, value: string }> | { label: string, value: string } | any;
    Excavator: string;
    TicketNum: string;
    TicketRevision: string;
    TicketType: string;
    ProfitCenter: { label: string, value: string } | null;
}

const maxSuggestedRendered: number = 25;
// const minSuggestedRendered: number = 10;

const now: number = Date.now();
const day: number = 1000 * 60 * 60 * 24;

const calculateScore = (compare: string, r: Result): number => (
    (r.Address?.toUpperCase().includes(compare) ? compare.length + 2 : 0) +
    (r.City?.toUpperCase().includes(compare) ? compare.length + 1 : 0) +
    (r.TicketNum?.includes(compare) ? compare.length + 3 : 0) +
    (r.Excavator?.toUpperCase().includes(compare) ? compare.length : 0) +
    (r.County?.toUpperCase().includes(compare) ? compare.length : 0) +
    (r.TicketType?.toUpperCase().includes(compare) ? compare.length : 0) +
    (r.ProfitCenter?.toUpperCase().includes(compare) ? compare.length + 1 : 0)
);

const splitString = (str: string): any => str.match(/"[^"]*"|\S+/g)
    ? str.match(/"[^"]*"|\S+/g)?.map((m: string) => m.slice(0, 1) === '"' ? m.slice(1, -1) : m)
    : str.split(" ");

export interface IProps {
    userId: any;
    searchTermChanged: any;
    resultsChanged: any;
    updateUserSettings: any;
    UserSettings: any;
    clearAllSavedFilters: any;
    selectFromQuickList: any;
    clearDetails: any;
    filteredLength: number;
    useExact: boolean;
    toggleExact: any;
    addFavoriteFilter: any;
}

const Header: React.FC<IProps> = (props: IProps) => {
    //r-18-lint-dj
    //eslint-disable-next-line
    const { userId, UserSettings, updateUserSettings, useExact, toggleExact, addFavoriteFilter, clearAllSavedFilters } = props;
    const [searchTerm, setSearchTerm] = React.useState("" as string);
    // const [tableSearchTerm, setTableSearchTerm] = React.useState("" as string);
    const [isSearching, setIsSearching] = React.useState(false as boolean);
    // const [results, setResults] = React.useState([] as Array<Result>);
    const results: any = React.useRef([]);
    const [suggested, setSuggested] = React.useState({ filters: [] as Array<Suggestion>, results: [] as Array<Result> });
    const [suggestedOpen, setSuggestedOpen] = React.useState(false as boolean);
    const [filtersOpen, setFiltersOpen] = React.useState(true as boolean);
    // const [suggestedRendered, setSugggestedRendered] = React.useState(minSuggestedRendered as number);
    const [options, setOptions] = React.useState({
        City: [],
        states: [],
        Excavator: [],
        profitCenters: []
    } as Options);
    const [filters, setFilters] = React.useState({
        startts: now - (14 * day),
        endts: now,
        Address: "",
        City: "",
        states: null,
        Excavator: "",
        TicketNum: "",
        TicketRevision: "",
        TicketType: "",
        ProfitCenter: null,
    } as Filters);
    const [showHint, setShowHint] = React.useState(true);
    const [optionsOpen, setOptionsOpen] = React.useState(false);
    const [closeSearchForm, setCloseSearchForm] = React.useState(false);
    const ref: any = React.useRef(null);
    const debouncedTerm = useDebounce(searchTerm);
    // const clickCallback = (e: any) => { e.preventDefault(); !showHint&&setFiltersOpen(false); }
    // useOnClickOutside(ref, clickCallback, ["modal", "ticket-search-menu", ".material-icons"]);
    let cancelTokenSource: any = React.useRef(axios.CancelToken.source());
    const query = useQuery();

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!suggestedOpen) { setSuggestedOpen(true); }
        setSearchTerm(e.target.value);
    }

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            //? handle table search and close suggestion dropdown
            setSuggestedOpen(false);
            filterAndSortResults();
            props.searchTermChanged(searchTerm)
        }
    }

    const handleStateSelect = (val: any) => { setFilters({ ...filters, states: val === null ? [] : val }); }

    const handlePCSelect = (val: any) => { setFilters({ ...filters, ProfitCenter: val }) }

    const handleDateChange = (val: any, name: string) => {
        let newFilters: any = { ...filters, [name]: name === "startts" ? val.hour(0).minute(0).valueOf() : val.hour(23).minute(59).valueOf() };
        setFilters(newFilters);
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        e.preventDefault();
        if (e.target.name === "startts") {
            if (e.target.value === undefined || e.target.value === "undefined" || e.target.value === "Custom") return;
            setFilters({ ...filters, [e.target.name]: Number(e.target.value) })
        }
        else { setFilters({ ...filters, [e.target.name]: e.target.value }); }
    }

    const handleFilterSelect = (e: any, s: Suggestion) => {
        e.preventDefault();
        if (showHint) { setShowHint(false); }
        setSuggestedOpen(false); //? Closing suggested dropdown menu
        let { fieldName, value, raw } = s;
        if (fieldName === "states") {
            let newStates: any = { value, label: raw.label };
            let newFilters = { ...filters, states: newStates };
            setFilters(newFilters);
            handleApply(newFilters)
        } else {
            let newFilters = { ...filters, [fieldName]: value };
            setFilters(newFilters);
            handleApply(newFilters);
        }
        generateSuggested(searchTerm);
        setSearchTerm(""); //? Clearing search term after selecting option
    }

    const generateSuggested = (value: string) => {
        let o: any = { ...options };
        let compare: string = value.replace(/['"]+/g, '').toUpperCase();
        let newSuggestedFilters: Array<Suggestion> = [];
        if (compare === "") { setSuggested({ results: [], filters: [] }); return; }
        let newSuggestedResults: Array<Result> = results?.current
            .filter((r: Result) => calculateScore(compare, r) > 0)
            .sort((a: Result, b: Result) => {
                let aScore: number = calculateScore(compare, a);
                let bScore: number = calculateScore(compare, b);
                return (aScore > bScore ? -1 : aScore < bScore ? 1 : 0);
            })
            .slice(0, maxSuggestedRendered);
        // let usedStates: Array<string> = [filters.states]?.map((o: any) => o.value);
        let usedStates: any = [];
        usedStates.push(filters.states?.value)
        Object.keys(o).forEach((key: any) => {
            //console.log("KEY: ", key);
            if (key === "states") {
                o.states.forEach((state: any) => {
                    if (state.name.toUpperCase().includes(compare) && !usedStates.includes(state.code)) {
                        newSuggestedFilters.push({
                            fieldName: "states",
                            value: state.code,
                            raw: { label: state.name }
                        });
                    }
                })
            }
            else if (key !== "profitCenters") {
                o[key].forEach((option: string) => {
                    let f: any = { ...filters };
                    //console.log("OPTION -> ", option);
                    if (option?.includes(compare) && !f[key].includes(compare)) {
                        newSuggestedFilters.push({
                            fieldName: key,
                            value: option,
                            raw: {}
                        });
                    }
                })
            }
        });
        setSuggested({ results: newSuggestedResults, filters: newSuggestedFilters.slice(0, 10) });
    }

    const generateOptions = (tickets: Array<Result>) => {
        //? Clears current options leaving states array
        let newOptions: any = { ...options, City: [], Excavator: [] };
        Object.keys(options).forEach((key: any) => {
            tickets.forEach((ticket: any) => {
                //? Ignoring states key and creating suggestions
                if (!newOptions[key].includes(ticket[key]) && Boolean(ticket[key]) && key !== "states") {
                    newOptions[key].push(ticket[key]);
                }
            })
        });
        setOptions(newOptions);
    }

    const handleApply = (newFilters: any = null) => {
        setIsSearching(true);
        if (showHint) { setShowHint(false); }
        let f: any = newFilters ? newFilters : { ...filters };
        let rb: any = {
            userId: userId,
            "startts": f.startts,
            "endts": f.endts,
            "street": f.Address,
            "city": f.City,
            "states": f.states.map((state: { label: string, value: string }) => state.value),  //Enable if multiselect is turned on
            // "states": typeof f.states === "string" ? f.states : f.states.value,
            "excavator": f.Excavator,
            "ticketNum": f.TicketNum,
            "ticketVer": f.TicketRevision,
            "memberCode": "",
            "ticketType": f.TicketType,
            "profitCenterId": f.ProfitCenter?.value
        };
        cancelTokenSource.current = axios.CancelToken.source();
        axios.post(process.env.REACT_APP_API_URL + "/api/TicketQuery/Search", rb,
            { ...AxiosConfig.configValue("min"), cancelToken: cancelTokenSource.current.token })
            .then((res: any) => {
                //console.log("Results: ", res);
                generateOptions(res.data);
                // setResults(res.data);
                results.current = res.data
                filterAndSortResults();
                if (closeSearchForm) {
                    setFiltersOpen(false);
                }
            })
            .catch((err: any) => {
                //console.log(err, err.response);
            })
            .finally(() => {
                setIsSearching(false)
            })
    }

    const handleClear = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setFilters({
            ...filters,
            Address: "",
            City: "",
            states: [],
            Excavator: "",
            TicketNum: "",
            TicketRevision: "",
            startts: now - (14 * day),
            endts: now,
            ProfitCenter: null,
        });
    }

    const handleToggle = (isOpen: boolean, event: any, metadata: { source: 'select' | 'click' | 'rootClose' | 'keydown' }) => {
        if (metadata.source === "click" || metadata.source === undefined) {
            setSuggestedOpen(isOpen);
        }
    }

    const handleFilterToggle = (isOpen: boolean, event: any, metadata: { source: 'select' | 'click' | 'rootClose' | 'keydown' }) => {
        if (metadata.source !== undefined && metadata.source !== "rootClose" && metadata.source !== "keydown") {
            setFiltersOpen(isOpen);
        }
    }

    const handleClearInput = (e: React.SyntheticEvent) => {
        e.preventDefault();
        filterAndSortResults(true);
    }

    const handleCancel = (e: React.SyntheticEvent) => {
        e.preventDefault();
        cancelTokenSource.current && cancelTokenSource.current.cancel();
    }

    // const removeState = (e: React.SyntheticEvent, code: string) => {
    //     e.preventDefault();
    //     //console.log("Remove State", filters);
    //     let f: any = { ...filters };
    //     f.states = filters.states.filter((state: any) => state.value !== code);
    //     setFilters(f);
    // }

    const handleSuggestionClick = (e: any, result: Result) => {
        e.preventDefault();
        props.selectFromQuickList(result);
        setSuggestedOpen(false);
    }

    const handleClearKeyDown = (e: any) => {
        e.preventDefault();
        if (e.keyCode === 9) {
            document.getElementById("ticket-search-submit")?.focus();
        }
    }

    const handleCloseOnSearchToggle = () => {
        setCloseSearchForm(!closeSearchForm);
        updateUserSettings({ ...UserSettings, TicketSearchCloseOnSearch: !closeSearchForm });
    }

    const checkForFilter = () => {
        if (query.get("filtername")) {
            let savedFilter: any = getSavedFilter("Ticket Search", query.get("filtername") || "");
            if (savedFilter && savedFilter?.states?.length) {
                //console.log("Saved Filter: ", savedFilter);
                let newFilters: any = { ...filters, ...savedFilter };
                setFilters(newFilters);
                handleApply(newFilters);
            }
        }
    }

    const filterAndSortResults = (clearSearch: boolean = false) => {
        const SearchTerm: string = clearSearch ? "" : searchTerm.toUpperCase();
        //console.log("Search Term from filterandsortresults", SearchTerm)
        props.resultsChanged(
            SearchTerm !== "" ?
                //? Filters results based on table search term 
                results?.current.filter((row: Result) => {
                    let split: Array<string> = useExact ? [SearchTerm] : splitString(SearchTerm);
                    let included: boolean = split.reduce((acc: boolean, comp: string) => (acc || calculateScore(comp.toUpperCase(), row) > 0), false);
                    return included;
                })
                    //? Sorts results based on suggestion score from calculateScore()
                    .sort((a: Result, b: Result) => {
                        let aScore: number = calculateScore(SearchTerm, a);
                        let bScore: number = calculateScore(SearchTerm, b);
                        return (aScore > bScore ? -1 : aScore < bScore ? 1 : 0);
                    })
                //? Truncates the list to the rendered amount to further improve performance
                : results?.current
            , () => {
                if (clearSearch) {
                    setSearchTerm("");
                    props.searchTermChanged("");
                }
            }
        );
    }

    //r-18-lint-dj
    //eslint-disable-next-line
    React.useEffect(() => { filterAndSortResults() }, [results.current, useExact])

    React.useEffect(() => {
        // clearAllSavedFilters()
        if (UserSettings?.TicketSearchCloseOnSearch) {
            setCloseSearchForm(UserSettings.TicketSearchCloseOnSearch);
        }
        query.get("ticketid") && setFiltersOpen(false);
        //? Loads available states and profit centers for given user on mount
        const getPC: any = axios.get(process.env.REACT_APP_API_URL + "/api/company/profitcenter/*", AxiosConfig.configValue("min"));
        const getStates: any = axios.get(process.env.REACT_APP_API_URL + "/api/TicketQuery/AllowedStates/?userId=" + userId, AxiosConfig.configValue("min"));
        axios.all([getPC, getStates])
            .then((res: any) => {
                const pcData: any = res[0].data;
                const stateData: any = res[1].data;
                let o: any = { ...options };
                o.states = stateData;
                o.profitCenters = pcData;
                //? Sets options.states to returned state list, this will remain constant throughout session
                //console.log("options", o);
                setOptions(o);
                checkForFilter();
            })
            .catch((err: any) => {
                //console.log("Error: ", err, err.response);
            })
        // eslint-disable-next-line 
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [])

    React.useEffect(() => {
        if (filters.states === null) { setShowHint(true); }
        else if (filters.states && showHint) { setTimeout(() => setShowHint(false), 250) }
        // eslint-disable-next-line 
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [filters])

    React.useEffect(() => {
        generateSuggested(debouncedTerm);
        // eslint-disable-next-line 
        //r-18-lint-dj
        //eslint-disable-next-line
    }, [debouncedTerm])

    //r-18-lint-dj
    //eslint-disable-next-line
    React.useEffect(() => { if (options.states.length) { checkForFilter(); } }, [query.get("filtername")])

    return (
        <>
            <Dropdown
                onToggle={handleFilterToggle}
                show={filtersOpen} // || ShowHint
                style={{
                    position: "fixed",
                    marginRight: "0.25rem",
                    width: document.getElementById("ticket-search-table")?.offsetWidth || "80%",
                    zIndex: 100
                }}
                className="d-flex flex-column"
            >
                <div className="d-flex flex-row align-items-center w-100">
                    <Dropdown className="w-100" show={suggestedOpen} onToggle={handleToggle}>
                        <Dropdown.Toggle as="div" className="remove-dropdown-arrow bg-none" id="ticket-search-toggle">
                            <InputGroup className="d-flex flex-row">
                                <InputGroup.Prepend>
                                    {searchTerm
                                        ? <InputGroup.Text onClick={handleClearInput} className="material-icons cursor-on-hover" style={{ fontSize: 24 }}>clear</InputGroup.Text>
                                        : <InputGroup.Text className="material-icons" style={{ fontSize: 24 }}>filter_alt</InputGroup.Text>
                                    }
                                </InputGroup.Prepend>
                                <input
                                    disabled={isSearching || showHint}
                                    onChange={handleSearch}
                                    onKeyPress={handleKeyPress}
                                    value={searchTerm}
                                    className="form-control ticket-search-input pullDown"
                                    placeholder="Filter Results"
                                    style={{ height: 50 }}
                                />
                            </InputGroup>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="w-60 shadow ticket-search-result-container">
                            <small className="text-secondary mb-1 pl-1">{suggested.results.length === 0 ? "No Matches" : "Top 5 matches"}, Click or press enter for all.</small>
                            {suggested.results.slice(0, 5)
                                .sort((a: Result, b: Result) => b.TicketID - a.TicketID)
                                .map((result: Result) => {
                                    const splitValue: Array<string> = splitString(debouncedTerm);
                                    return (
                                        <React.Fragment key={result.TicketID}>
                                            <Dropdown.Item onClick={e => handleSuggestionClick(e, result)} bsPrefix="p-1 border-0 ticket-search-result mb-2" as="div" key={result.TicketID}>
                                                <div className="d-flex flex-row justify-content-center align-items-center">
                                                    <i className="material-icons px-2 text-secondary">text_snippet</i>
                                                    <div className="d-flex flex-column">
                                                        <strong style={{ marginBottom: 5 }}>Ticket #: <Highlighter highlightClassName="elm-blue-highlight" searchWords={splitValue} textToHighlight={result.TicketNum || ""} /></strong>
                                                        <small className="d-flex flex-column">
                                                            <Highlighter highlightClassName="elm-blue-highlight" searchWords={splitValue} textToHighlight={result.Address || ""} />
                                                            <Highlighter highlightClassName="elm-blue-highlight" searchWords={splitValue} textToHighlight={`${result.County ? result.County + ", " : ""}${result.State || ""}`} />
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-column align-items-end">
                                                    <span style={{ marginBottom: 5 }}>{dayjs(result.ImportDate).format("MM/DD/YYYY")}</span>
                                                    <small className="text-secondary">
                                                        <Highlighter highlightClassName="elm-blue-highlight" searchWords={splitValue} textToHighlight={result.Excavator || ""} />
                                                    </small>
                                                </div>
                                            </Dropdown.Item>
                                            {/* <Dropdown.Divider className="m-0" /> */}
                                        </React.Fragment>)
                                })}
                            <Dropdown.Divider />
                            {suggested.filters.length > 0 && <span className="text-secondary pl-1 mb-1">Send to Search</span>}
                            {suggested.filters.slice(0, 5).map((s: Suggestion, i: number) => (
                                <Dropdown.Item key={i} bsPrefix="p-1 suggestion-result" as="div" onClick={e => handleFilterSelect(e, s)}>
                                    <i className="material-icons px-2 text-secondary">search</i>
                                    {s.fieldName === "states" && <span><strong>State: </strong>{s.value}</span>}
                                    {s.fieldName !== "states" && <span><strong>{s.fieldName}: </strong>{s.value}</span>}
                                </Dropdown.Item>
                            ))}
                            {(suggested.results.length === 0 && suggested.filters.length === 0) && <Dropdown.Item className="text-center">No Suggestions</Dropdown.Item>}
                        </Dropdown.Menu>
                    </Dropdown>
                    {isSearching &&
                        <div id="ticket-search-loading-container">
                            <i onClick={handleCancel} title="Cancel Request" className="material-icons text-danger">cancel</i>
                            <Spinner className="ticket-search-loading-indicator" size="sm" animation="border" />
                        </div>
                    }
                    <Dropdown.Toggle as="span" className={`remove-dropdown-arrow material-icons ticket-search-toggle ${!isSearching && "action-text"}`}>{
                        filtersOpen
                            ? "expand_less"
                            :
                            //@ts-ignore
                            Object.keys(filters as any).reduce((acc: number, cur: any) => (filters[cur] &&
                                cur !== "startts" &&
                                cur !== "endts" &&
                                cur !== "states") ? acc + 1 : acc, 0) > 0
                                ? "manage_search" : "search"
                    }</Dropdown.Toggle>
                </div>
                <Dropdown.Menu ref={ref} className="px-2 ticket-search-menu">
                    <Form onSubmit={(e: any) => {
                        e.preventDefault();
                        if (!filters.states || isSearching) {
                            handleApply();
                        }
                    }}>
                        <Form.Row className="ticket-search-menu-item d-flex flex-row" style={{ marginBottom: 5 }}>
                            <div className="d-flex flex-column col-sm-12 col-md-4">
                                <label>State: </label>
                                <Select
                                    isMulti
                                    name="states"
                                    onChange={handleStateSelect}
                                    isDisabled={options && options.states.length === 0}
                                    isLoading={options && options.states.length === 0}
                                    placeholder={options && options.states.length === 0 ? "Loading..." : "Select at least one state to begin your search"}
                                    options={options.states.map((state: StateOption) => ({ value: state.code, label: state.name }))}
                                    value={filters.states || []}
                                    className="z-100 w-100"
                                    styles={{
                                        container: (provided: any) => ({ ...provided, width: "calc(100% - 125px)" }),
                                        placeholder: (provided: any) => ({ ...provided, color: (showHint && options.states.length) ? "#E15562" : "auto" })
                                    }}
                                />
                            </div>
                            <div className="d-flex flex-column col-sm-12 col-md-8">
                                <label>Date Range:</label>
                                <div className="d-flex flex-row">
                                    <TimeAgoSelect start={now} style={{ maxWidth: 110 }} name="startts" onChange={handleChange} value={filters.startts} className="form-control" />
                                    <div style={{ width: "calc(100% - 110px)" }} className="d-flex align-items-center justify-content-between flex-wrap">
                                        <DatePicker appendClassName="border-top-0 border-right-0" name="startts" inputWrapperClassName="w-50" value={filters.startts} onChange={handleDateChange} type="input" useCloseCallback />
                                        <DatePicker appendClassName="border-top-0 border-right-0" name="endts" inputWrapperClassName="w-50" value={filters.endts} onChange={handleDateChange} type="input" useCloseCallback />
                                    </div>
                                    {!optionsOpen && <IconButton disabled={!filters.states || isSearching} showSpinner={isSearching} onClick={e => { e.preventDefault(); handleApply(); }} icon="search">Search</IconButton>}
                                </div>
                            </div>
                        </Form.Row>
                        <CollapsibleArea startOpen={false} Toggle={(p: any) =>
                            <div onClick={(e: React.SyntheticEvent) => {
                                setOptionsOpen(!optionsOpen);
                                p.onClick(e);
                            }} className="text-center ticket-search-form-toggle"
                            >
                                {p.open ? "Less" : "More"} Options&nbsp;(
                                {
                                    //@ts-ignore
                                    Object.keys(filters as any).reduce((acc: number, cur: any) => (filters[cur] &&
                                        cur !== "startts" &&
                                        cur !== "endts" &&
                                        cur !== "states") ? acc + 1 : acc, 0)
                                }
                                &nbsp; Active)
                            </div>
                        }>
                            <Form.Row className="ticket-search-menu-item">
                                <label>Ticket #:</label>
                                <div className="ticket-search-input">
                                    <FormControlClear field="#ticket-search-ticket-num-field" />
                                    <Form.Control id="ticket-search-ticket-num-field" name="TicketNum" type="text" placeholder="Ticket #" value={filters.TicketNum} onChange={handleChange} />
                                </div>
                                <label>Ticket Revision: </label>
                                <div className="ticket-search-input">
                                    <Form.Control id="ticket-search-ticket-rev-field" name="TicketRevision" type="text" placeholder="Version" value={filters.TicketRevision} onChange={handleChange} />
                                    <FormControlClear field="#ticket-search-ticket-rev-field" />
                                </div>
                            </Form.Row>
                            <Form.Row className="ticket-search-menu-item">
                                <label>Address: </label>
                                <div className="ticket-search-input">
                                    <FormControlClear field="#ticket-search-address-field" />
                                    <Form.Control id="ticket-search-address-field" name="Address" type="text" placeholder="Street" value={filters.Address} onChange={handleChange} />
                                </div>
                            </Form.Row>
                            <Form.Row className="ticket-search-menu-item">
                                <label>City: </label>
                                <div className="ticket-search-input">
                                    <FormControlClear field="#ticket-search-city-field" />
                                    <Form.Control id="ticket-search-city-field" name="City" type="text" placeholder="City" value={filters.City} onChange={handleChange} />
                                </div>
                            </Form.Row>
                            <Form.Row className="ticket-search-menu-item">
                                <label>Excavator: </label>
                                <div className="ticket-search-input">
                                    <FormControlClear field="#ticket-search-excavator-field" />
                                    <Form.Control id="ticket-search-excavator-field" name="Excavator" type="text" placeholder="Excavator" value={filters.Excavator} onChange={handleChange} />
                                </div>
                            </Form.Row>
                            <Form.Row className="ticket-search-menu-item">
                                <label>Ticket Type: </label>
                                <div className="ticket-search-input">
                                    <FormControlClear field="#ticket-search-tickettype-field" />
                                    <Form.Control id="ticket-search-tickettype-field" name="TicketType" type="text" placeholder="Ticket Type" value={filters.TicketType} onChange={handleChange} />
                                </div>
                            </Form.Row>
                            <Form.Row className="ticket-search-menu-item">
                                <label>Profit Center: </label>
                                <Select
                                    isMulti={false}
                                    name="ProfitCenter"
                                    onChange={handlePCSelect}
                                    placeholder="Profit Center"
                                    options={options?.profitCenters
                                        .filter((pc: any) => filters.states?.findIndex((option: any) => option.value === pc.stateCode) >= 0)
                                        .map((pc: { profitCenterName: string, stateCode: string, profitCenterId: any }) => ({ value: pc.profitCenterId, label: pc.profitCenterName }))}
                                    value={filters.ProfitCenter}
                                    styles={{ container: (provided: any) => ({ ...provided, width: "calc(100% - 125px)" }) }}
                                />
                            </Form.Row>
                            <Form.Row style={{ marginTop: 20 }} className="d-flex justify-content-between align-items-center">
                                {/* <Checkbox
                                    label="Add to Favorites"
                                    isChecked
                                    onChange={saveToFavorites}
                                    isCheckedIcon="favorite"
                                    notCheckedIcon="favorite"
                                /> */}
                                <Checkbox
                                    label="Close on Search"
                                    isChecked={closeSearchForm}
                                    onChange={handleCloseOnSearchToggle}
                                />
                                <div className="d-flex flex-row align-items-center">
                                    <IconButton onKeyPress={handleClearKeyDown} type="button" onClick={handleClear} buttonClassName="ml-auto btn btn-outline-danger" icon="clear">Clear Search</IconButton>
                                    <IconButton id="ticket-search-submit" type="submit" disabled={!filters.states || isSearching} showSpinner={isSearching} onClick={e => { e.preventDefault(); handleApply(); }} icon="search">Search</IconButton>
                                </div>
                            </Form.Row>
                        </CollapsibleArea>
                    </Form>
                </Dropdown.Menu>
                <div className="d-flex flex-row align-items-center bg-white w-100 pt-1">
                    <span style={{ marginRight: 20 }} className="text-primary">Showing {props.filteredLength}/{results.current.length}</span>
                    <Form.Check label="Match Exact" onChange={() => { toggleExact(); }} checked={useExact} />
                </div>
            </Dropdown>
        </>
    );
}

const mapStateToProps = (state: AppState) => ({ UserSettings: state.user.UserSettings })

export default connect(mapStateToProps, { updateUserSettings, clearAllSavedFilters, addFavoriteFilter })(Header);